import React from "react";
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <Helmet>
        <title>{t('about.meta_title')}</title>
        <meta name="description" content={t('about.meta_description')} />
        <link rel="canonical" href='https://237mechanic.com/cm/en/about-us' />

      </Helmet>
      
      <h1 className="text-3xl font-bold mb-4">{t('about.title')}</h1>
      
      <div className="text-gray-700 mb-4 space-y-4">
        <p>{t('about.intro')}</p>
        <p><strong>{t('about.vision_label')}:</strong></p>
        <p>{t('about.vision_text')}</p>
      </div>
    </div>
  );
}

export default AboutUs;